var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4341 23.8571C17.749 23.8571 22.8683 18.7404 22.8683 12.4286C22.8683 6.11675 17.749 1 11.4341 1C5.11924 1 0 6.11675 0 12.4286C0 18.7404 5.11924 23.8571 11.4341 23.8571ZM14.3608 7.87996H16.12C16.606 7.87996 17 8.27395 17 8.75996C17 9.24597 16.606 9.63996 16.12 9.63996H6.88C6.39399 9.63996 6 9.24597 6 8.75996C6 8.27395 6.39399 7.87996 6.88 7.87996H8.64079C8.64081 7.39397 9.03479 7 9.52079 7H13.4808C13.9668 7 14.3608 7.39397 14.3608 7.87996ZM9.17588 10.0781H6.87891L7.17784 12.1707C7.18074 12.2311 7.18639 12.292 7.1949 12.3533L7.73934 16.2733C7.87667 17.262 8.72207 17.9981 9.72033 17.9981H13.2775C14.2757 17.9981 15.1211 17.262 15.2585 16.2733L15.8029 12.3533C15.8114 12.292 15.8171 12.2311 15.82 12.1707L16.1189 10.0781H13.8219H9.17588Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash_icon.abb9399a28fab68a13558ad946441d75.svg";
export { ForwardRef as ReactComponent };